import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentStep: null,
  promptType: null,
  bigin: {
    pipelineId: null,
    data: null,
  },
  project: {
    id: null,
  },
  knowledgeBase: {
    id: null,
  },
  success: false,
};

const onboardingSlice = createSlice({
  name: 'onboardingSlice',
  initialState,
  reducers: {
    setBigin: (state, action) => {
      state.bigin = action.payload;
    },
    setProject: (state, action) => {
      state.project = action.payload;
    },
    setKnowledgeBase: (state, action) => {
      state.knowledgeBase = action.payload;
    },
    setPromptType: (state, action) => {
      state.promptType = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setSuccess: (state, action) => {
      return { ...initialState, success: action.payload };
    },
    clearOnboardingState: (state) => {
      return { ...initialState };
    },
  },
});

export const {
  setBigin,
  setProject,
  setKnowledgeBase,
  setCurrentStep,
  setSuccess,
  clearOnboardingState,
  setPromptType,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
